import DishesList from './DishesList';

export default DishesList;
